module.exports = __webpack_public_path__ + "static/media/sahil_malawde.3e0bb338.png";